import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FaSteam } from 'react-icons/fa';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

// Use the correct variable name from your .env file
const API_BASE = process.env.REACT_APP_API_BASE_URL;

const SteamSignIn = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");

  useEffect(() => {
    if (error) {
      toast.error(decodeURIComponent(error));
      // Clean up URL params without a page reload
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, [error]);

  const handleSignIn = () => {
    if (!API_BASE) {
      console.error("API base URL is not defined");
      return;
    }

    // Dynamically use the current origin for the redirect back after Steam login
    const redirectTo = window.location.origin;
    window.location.href = `${API_BASE}/auth/steam?redirect=${encodeURIComponent(redirectTo)}`;
  };

  return (
      <Button
          className="h-10 flex items-center gap-2"
          variant="contained"
          color="primary"
          onClick={handleSignIn}
      >
        <FaSteam className="w-5 h-5" />
        {t('signIn.SignInButton')}
      </Button>
  );
};

export default SteamSignIn;